'use strict';/* global define */define('modules/users/services/user-list/index',['require','exports','module','util/array-remove'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$filter", "Users", "Modals"];
function factory($filter,Users,Modals){// jshint validthis:true
// jshint latedef:false
var remove=require('util/array-remove');var translate=$filter('translate');return{addUser:addUser,removeUser:removeUser};// ---
/**
     * Add user to a given list by calling API
     * and then modifying the list handed in by
     * reference
     *
     * !!! List has to have predefined `$type` attribute
     *
     * @param {Object} user       - user object
     * @param {Array}  list       - given list
     *
     * @tested
     */function addUser(user,list,failureMsg){var message=translate(failureMsg,user);var actions={'key-performers':Users.addKeyPerformer,'watchlist':Users.addWatchlistUser};if(actions[list.$type]){actions[list.$type](user).$promise.then(function(user){list.push(user);}).catch(function(){Modals.alert(message);});}}/**
     * Remove user from a given list by calling API
     * and then modifying the list handed in by
     * reference
     *
     * !!! List has to have predefined `$type` attribute
     *
     * @param {Object} user       - user object
     * @param {Array}  list       - given list
     *
     * @tested
     */function removeUser(user,list,confirmKey){var actions={'key-performers':Users.removeKeyPerformer,'watchlist':Users.removeWatchlistUser};if(actions[list.$type]){var confirm=function confirm(){actions[list.$type](user).$promise.then(function(){remove(list,user);}).catch(Modals.fail);};var confirmMsg=translate(confirmKey,user);Modals.confirm(confirmMsg,confirm);}}}module.exports=factory;});
